import { createRouter, createWebHistory } from "vue-router";
//import Default from "../views/dashboards/Default.vue";
import Sales from "../views/dashboards/Sales.vue";
import Overview from "../views/pages/profile/Overview.vue";
import Projects from "../views/pages/profile/Projects.vue";
import Timeline from "../views/pages/projects/Timeline.vue";
import Pricing from "../views/pages/Pricing.vue";
import RTL from "../views/pages/Rtl.vue";
import Charts from "../views/pages/Charts.vue";
import Notifications from "../views/pages/Notifications.vue";
import Kanban from "../views/applications/Kanban.vue";
import Wizard from "../views/applications/wizard/Wizard.vue";
import DataTables from "../views/applications/DataTables.vue";
import Calendar from "../views/applications/Calendar.vue";
import NewProduct from "../views/ecommerce/products/NewProduct.vue";
import EditProduct from "../views/ecommerce/products/EditProduct.vue";
import ProductPage from "../views/ecommerce/products/ProductPage.vue";
import OrderDetails from "../views/ecommerce/orders/OrderDetails";
import OrderList from "../views/ecommerce/orders/OrderList";
import NewUser from "../views/pages/users/NewUser.vue";
//import Settings from "../views/pages/account/Settings.vue";
import Billing from "../views/pages/account/Billing.vue";
import Invoice from "../views/pages/account/Invoice.vue";
import Widgets from "../views/pages/Widgets.vue";
import Basic from "../views/auth/signin/Basic.vue";
import Cover from "../views/auth/signin/Cover.vue";
import Illustration from "../views/auth/signin/Illustration.vue";
import ResetCover from "../views/auth/reset/Cover.vue";
import SignupCover from "../views/auth/signup/Cover.vue";
import Error403 from "../views/pages/Error403.vue";

// 내가 만든 페이지
import WebSocketTest from "@/views/tests/WebSocketTest.vue";
import SpontaneousSpeakingTest from "@/views/tests/SpontaneousSpeakingTest.vue";
import AIWritingTest from "@/views/tests/AIWritingTest.vue";
import PaymentSalesList from "@/views/payment/PaymentSalesList.vue";
import CouponManager from "@/views/payment/CouponManager.vue";
import SettlementInvoiceRequest from "@/views/settlement/SettlementInvoiceRequest.vue";
import SettlementCompleted from "@/views/settlement/SettlementCompleted.vue";
import UsersManagers from "@/views/users/UsersManagers.vue";
import UsersEditors from "@/views/users/UsersEditors.vue";
import UsersIL from "@/views/users/UsersIL.vue";
import UserDetail from "@/views/users/UserDetail.vue";
import ManagerDetail from "@/views/users/ManagerDetail.vue";
import EditorDetail from "@/views/users/EditorDetail.vue";
import ContentsTextbooks from "@/views/contents/ContentsTextbooks.vue";
import ContentsAudiobooks from "@/views/contents/ContentsAudiobooks.vue";
import ContentsVideos from "@/views/contents/ContentsVideos.vue";
import EditTextbook from "@/views/contents/EditTextbook.vue";
import EditTextbookContents from "@/views/contents/EditTextbookContents.vue";
import EditWordsAndExpressions from "@/views/contents/EditWordsAndExpressions.vue";
import AcademicClasses from "@/views/academic/AcademicClasses.vue";
import AcademicClassesDetail from "@/views/academic/AcademicClassesDetail.vue";
import AcademicEvaluations from "@/views/academic/AcademicEvaluations.vue";
import AcademicQuestionBank from "@/views/academic/AcademicQuestionBank.vue";
import AcademicPipScoringFailures from "@/views/academic/AcademicPipScoringFailures.vue";
import ImageAssetPopup from "@/views/popup/ImageAssetPopup.vue";
import SystemSecurityPages from "@/views/system/SystemSecurityPages.vue";
import SystemDbAnalyzer from "@/views/system/SystemDbAnalyzer.vue";
import SystemEmailMassages from "@/views/system/SystemEmailMassages.vue";
import SystemPushMassages from "@/views/system/SystemPushMassages.vue";
import SystemLogsSchedules from "@/views/system/SystemLogsSchedules.vue";
import SystemLogsErrors from "@/views/system/SystemLogsErrors.vue";
import SystemLogsHistory from "@/views/system/SystemLogsHistory.vue";
import SystemLogsAiCalls from "@/views/system/SystemLogsAiCalls.vue";
import SystemAiSettings from "@/views/system/SystemAiSettings.vue";
import SystemLegalDocuments from "@/views/system/SystemLegalDocuments.vue";
import SystemLegalDocumentDetail from "@/views/system/SystemLegalDocumentDetail.vue";
import SystemLegalVersionEditor from "@/views/system/SystemLegalVersionEditor.vue";
import SystemLegalConsents from "@/views/system/SystemLegalConsents.vue";
import SystemHomeSections from "@/views/system/SystemHomeSections.vue";
import SystemHomeSectionDetail from "@/views/system/SystemHomeSectionDetail.vue";
import HelpDeskFAQs from "@/views/helpDesk/HelpDeskFAQs.vue";
import HelpDeskInquiry from "@/views/helpDesk/HelpDeskInquiry.vue";
import HelpDeskInstructorLibrary from "@/views/helpDesk/HelpDeskInstructorLibrary.vue";
import VoucherOrganizations from "@/views/voucher/VoucherOrganizations.vue";
import VoucherOrganizationDetail from "@/views/voucher/VoucherOrganizationDetail.vue";
import VoucherMasters from "@/views/voucher/VoucherMasters.vue";
import VoucherPurchases from "@/views/voucher/VoucherPurchases.vue";
import VoucherVouchers from "@/views/voucher/VoucherVouchers.vue";

import store from "@/store"; // Vuex store를 가져옵니다.

const routes = [
  {
    path: "/",
    redirect: "/dashboards/dashboard-default",
  },
  {
    path: "/dashboards",
    name: "Dashboards",
    children: [
      {
        path: "dashboard-default",
        name: "Default",
        //component: Default,
        component: Sales, // sales로 바꾸기
      },
      {
        path: "sales",
        name: "Sales",
        component: Sales,
      },
    ],
  },  
  {
    path: "/pages",
    name: "Pages",
    children: [
      {
        path: "profile/overview",
        name: "Profile Overview",
        component: Overview,
      },
      {
        path: "profile/projects",
        name: "All Projects",
        component: Projects,
      },
      {
        path: "projects/timeline",
        name: "Timeline",
        component: Timeline,
      },
      {
        path: "pricing-page",
        name: "Pricing Page",
        component: Pricing,
      },
      {
        path: "rtl-page",
        name: "RTL",
        component: RTL,
      },
      {
        path: "charts",
        name: "Charts",
        component: Charts,
      },
      {
        path: "widgets",
        name: "Widgets",
        component: Widgets,
      },
      {
        path: "notifications",
        name: "Notifications",
        component: Notifications,
      },
      {
        path: "users/new-user",
        name: "New User",
        component: NewUser,
      },
      {
        path: "account/billing",
        name: "Billing",
        component: Billing,
      },
      {
        path: "account/invoice",
        name: "Invoice",
        component: Invoice,
      },
    ],
  },
  {
    path: "/applications",
    name: "Applications",
    children: [
      {
        path: "kanban",
        name: "Kanban",
        component: Kanban,
      },
      {
        path: "wizard",
        name: "Wizard",
        component: Wizard,
      },
      {
        path: "data-tables",
        name: "Data Tables",
        component: DataTables,
      },
      {
        path: "calendar",
        name: "Calendar",
        component: Calendar,
      },
    ],
  },
  {
    path: "/ecommerce",
    name: "Ecommerce",
    children: [
      {
        path: "products/new-product",
        name: "New Product",
        component: NewProduct,
      },
      {
        path: "products/edit-product",
        name: "Edit Product",
        component: EditProduct,
      },
      {
        path: "products/product-page",
        name: "Product Page",
        component: ProductPage,
      },
      {
        path: "orders/order-details",
        name: "Order Details",
        component: OrderDetails,
      },
      {
        path: "orders/order-list",
        name: "Order List",
        component: OrderList,
      },
    ],
  },
  {
    path: "/authentication",
    name: "Authentication",
    children: [
      {
        path: "signin/basic",
        name: "Signin Basic",
        component: Basic,
      },
      {
        path: "signin",
        name: "Signin Cover",
        component: Cover,
      },
      {
        path: "signin/illustration",
        name: "Signin Illustration",
        component: Illustration,
      },
      {
        path: "reset/cover",
        name: "Reset Cover",
        component: ResetCover,
      },
      {
        path: "signup",
        name: "Signup Cover",
        component: SignupCover,
      },
      {
        path: "/logout",
        name: "Logout",
        beforeEnter(to, from, next) {
          //console.log("로그아웃 시작");
          store
            .dispatch("auth/logout") // Vuex Store에서 로그아웃 액션 호출
            .then(() => {
              //console.log("로그아웃 완료");
              // 로그아웃 후 로그인 페이지로 리다이렉트
              next({ path: "/authentication/signin" });
            })
            .catch((err) => {
              console.error("로그아웃 중 오류 발생:", err);
              // 오류가 발생해도 로그인 페이지로 이동
              next({ path: "/authentication/signin" });
            });
        },
      }
    ],
  },
  {
    path: "/pages/error/403",
    name: "Error403",
    component: Error403,
  },
  // 내가 새롭게 만든 라우트
  {
    path: "/payment",
    name: "Payment",
    children: [
      {
        path: "sales",
        name: "PaymentSales",
        component: PaymentSalesList,
      },
      {
        path: "coupons",
        name: "PaymentCoupons",
        component: CouponManager,
      },      
    ]
  },
  {
    path: "/settlement",
    name: "Settlement",
    children: [
      {
        path: "invoiceRequest",
        name: "SettlementInvoiceRequest",
        component: SettlementInvoiceRequest,
      },
      {
        path: "completed",
        name: "SettlementCompleted",
        component: SettlementCompleted,
      }      
    ]
  },
  // 바우처 기관발행 (docs/바우처_기관발행_관리자화면_가이드.md §1).
  // page 테이블에는 목록 4건만 등록됩니다. 기관 상세는 /voucher/organizations 아래에 두어
  // 라우터 가드(getPageAuthInfo)의 `startsWith(uri + '/')` 매칭으로 목록 권한을 상속합니다.
  {
    path: "/voucher",
    name: "Voucher",
    children: [
      {
        path: "organizations",
        name: "VoucherOrganizations",
        component: VoucherOrganizations,
      },
      {
        path: "organizations/:organizationIdx(\\d+)",
        name: "VoucherOrganizationDetail",
        component: VoucherOrganizationDetail,
        props: true,
      },
      {
        path: "masters",
        name: "VoucherMasters",
        component: VoucherMasters,
      },
      {
        path: "purchases",
        name: "VoucherPurchases",
        component: VoucherPurchases,
      },
      {
        path: "vouchers",
        name: "VoucherVouchers",
        component: VoucherVouchers,
      },
    ]
  },
  {
    path: "/users",
    name: "Users",
    children: [
      {
        path: "managers",
        name: "UsersManagers",
        component: UsersManagers,
      },
      {
        path: "managers/detail",
        name: "ManagerDetail",
        component: ManagerDetail,
      },
      {
        path: "editors",
        name: "UsersEditors",
        component: UsersEditors,
      },
      {
        path: "editor/detail",
        name: "EditorDetail",
        component: EditorDetail,
      },
      {
        path: "usersIL",
        name: "UsersIL",
        component: UsersIL,
      },
      {
        path: "usersIL/detail",
        name: "UserDetail",
        component: UserDetail,
      }
    ]
  },
  {
    path: "/contents",
    name: "Contents",
    children: [
      {
        path: "textbooks",
        name: "ContentsTextbooks",
        component: ContentsTextbooks,
      },
      {
        path: "audiobooks",
        name: "ContentsAudiobooks",
        component: ContentsAudiobooks,
      },
      {
        path: "videos",
        name: "ContentsVideos",
        component: ContentsVideos,
      },
      {
        path: "editTextbook",
        name: "EditTextbook",
        component: EditTextbook,
      },
      {
        path: "editTextbookContents",
        name: "EditTextbookContents",
        component: EditTextbookContents,
      },
      {
        path: "editWordsAndExpressions",
        name: "EditWordsAndExpressions",
        component: EditWordsAndExpressions,
      }
    ]
  },
  {
    path: "/academic",
    name: "Academic",
    children: [
      {
        path: "classes",
        name: "AcademicClasses",
        component: AcademicClasses,
      },
      {
        path: "evaluations",
        name: "AcademicEvaluations",
        component: AcademicEvaluations,
      },
      {
        path: "questionBank",
        name: "AcademicQuestionBank",
        component: AcademicQuestionBank,
      },
      {
        path: "classesDetail",
        name: "AcademicClassesDetail",
        component: AcademicClassesDetail,
      },
      // PIP 채점 실패 복구(docs/PIP_채점실패_복구.md §2-1). page 테이블 등록은 플랫폼 백엔드 마이그레이션 b7e4c2a9d5f1
      // (academic:view, 일반 관리자 기본). 등록 전에는 super_admin 에게만 열립니다.
      {
        path: "pipScoringFailures",
        name: "AcademicPipScoringFailures",
        component: AcademicPipScoringFailures,
      }
    ]
  },
  {
    path: "/system",
    name: "System",
    children: [
      {
        path: "security",
        name: "SystemSecurity",
        children: [
          {
            path: "pages",
            name: "SystemSecurityPages",
            component: SystemSecurityPages,
          }
        ]
      },
      {
        path: "dbAnalyzer",
        name: "SystemDbAnalyzer",
        component: SystemDbAnalyzer,
      },
      {
        path: "emailMassages",
        name: "SystemEmailMassages",
        component: SystemEmailMassages,
      },
      {
        path: "pushMassages",
        name: "SystemPushMassages",
        component: SystemPushMassages,
      },
      // 앱 홈 진열(큐레이션). 상세를 목록의 하위 경로에 두면 라우터 가드(getPageAuthInfo)가
      // `to_path.startsWith(uri + '/')` 로 매칭하므로 page 테이블 권한은 /system/homeSections 1건이면 됩니다.
      {
        path: "homeSections",
        name: "SystemHomeSections",
        component: SystemHomeSections,
      },
      {
        path: "homeSections/:sectionIdx(\\d+)",
        name: "SystemHomeSectionDetail",
        component: SystemHomeSectionDetail,
        props: true,
      },
      // page 테이블에 등록된 권한은 /system/legalDocuments 하나뿐입니다.
      // 라우터 가드(getPageAuthInfo)가 `to_path.startsWith(uri + '/')` 로 하위 경로를 매칭하므로,
      // 증빙 조회·버전 관리·에디터를 전부 이 경로 아래에 두어 권한 1건을 상속받게 합니다.
      {
        path: "legalDocuments",
        name: "SystemLegalDocuments",
        component: SystemLegalDocuments,
      },
      {
        path: "legalDocuments/consents",
        name: "SystemLegalConsents",
        component: SystemLegalConsents,
      },
      // documentId 는 문자열이라 'consents' 와 겹칠 수 있어 /doc/ 세그먼트로 분리합니다.
      {
        path: "legalDocuments/doc/:documentId",
        name: "SystemLegalDocumentDetail",
        component: SystemLegalDocumentDetail,
        props: true,
      },
      {
        path: "legalDocuments/doc/:documentId/editor",
        name: "SystemLegalVersionEditor",
        component: SystemLegalVersionEditor,
        props: true,
      },
      {
        path: "logs",
        name: "SystemLogs",
        children: [
          {
            path: "schedules",
            name: "SystemLogsSchedules",
            component: SystemLogsSchedules,
          },
          {
            path: "errors",
            name: "SystemLogsErrors",
            component: SystemLogsErrors,
          },
          {
            path: "history",
            name: "SystemLogsHistory",
            component: SystemLogsHistory,
          },
          {
            path: "aiCalls",
            name: "SystemLogsAiCalls",
            component: SystemLogsAiCalls,
          }
        ]
      },
      {
        path: "aiSettings",
        name: "SystemAiSettings",
        component: SystemAiSettings,
      },
    ]
  },
  {
    path: "/helpDesk",
    name: "Help Desk",
    children: [
      {
        path: "faqs",
        name: "HelpDeskFAQs",
        component: HelpDeskFAQs,
      },
      {
        path: "inquiry",
        name: "HelpDeskInquiry",
        component: HelpDeskInquiry,
      },
      {
        path: "instructorLibrary",
        name: "HelpDeskInstructorLibrary",
        component: HelpDeskInstructorLibrary,
      }
    ]
  },
  // 테스트 페이지 추가
  {
    path: "/tests",
    name: "Tests",
    children: [
      {
        path: "websocket",
        name: "WebSocketTest",
        component: WebSocketTest,
      },
      {
        path: "spontaneousSpeaking",
        name: "SpontaneousSpeakingTest",
        component: SpontaneousSpeakingTest,
      },
      {
        path: "aiWriting",
        name: "AIWritingTest",
        component: AIWritingTest,
      },
    ]
  },
  // 팝업 페이지 (레이아웃 없음)
  {
    path: "/popup/image-assets",
    name: "ImageAssetPopup",
    component: ImageAssetPopup,
    meta: { layout: 'empty' } // 레이아웃 없이 컴포넌트만 표시
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

export default router;
